import { render, staticRenderFns } from "./RiskProfile.vue?vue&type=template&id=787a01ce"
import script from "./RiskProfile.vue?vue&type=script&lang=js"
export * from "./RiskProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports